import { render, staticRenderFns } from "./DissociatesPersonDialog.vue?vue&type=template&id=f6a4fca2"
import script from "./DissociatesPersonDialog.vue?vue&type=script&lang=js"
export * from "./DissociatesPersonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports